import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PayloadBuilderTable from './PayloadBuilderTable.jsx';
import PayloadBuilderObject from './PayloadBuilderObject.jsx';
import { escapeEmptyDetail } from '../../utils/utils';
import DetailItem from '../DetailItem/DetailItem.jsx';

const PayloadBuilder = (props) => {

  const payload = props.payload;
  
  const payloadElements = () => {
    let elements = [];

      for (const [key, value] of Object.entries(payload)) {
        if (value && Array.isArray(value)) {
          elements.push(<DetailItem key={key} title={key} content={<PayloadBuilderTable payload={value} />} />)
        } else if (value && typeof value === 'object') {
            if (value !== null)
              elements.push(<PayloadBuilderObject key={key} title={key} payload={value} />)
            else
              elements.push(<DetailItem key={key} title={key} content={escapeEmptyDetail(value)} />)
        } else 
          elements.push(<DetailItem key={key} title={key} content={escapeEmptyDetail(value)} />)
      }
    return elements;
  }

  return (
    <>
      { payload &&
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{flexDirection: 'row-reverse'}}>
            <p className='detail-title'>Payload</p>
          </AccordionSummary>
          <AccordionDetails >
            {payloadElements()}
          </AccordionDetails>
        </Accordion>
      }
    </>
  );
};

export default PayloadBuilder